// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sx-page {\n  padding: 25px;\n  margin: 0 auto;\n  max-width: 1024px;\n}\n.sx-page-content {\n  margin-top: 22px;\n}\n.sx-page-content > * {\n  margin-top: 35px;\n}\n.sx-page-content > *:first-child {\n  margin-top: 0px !important;\n}", ""]);
// Exports
module.exports = exports;
